import {WoodMixSource} from './wood-mix.js';

function selected(value){
  const text=String(value||'').trim();
  const match=/^(catalogue|inventory):(.+)$/.exec(text);
  if(!match)throw new TypeError('Select a valid wood source');
  return {kind:match[1],id:match[2]};
}

function percent(value){
  if(value==null||value==='')return null;
  const number=Number(value);
  if(!Number.isFinite(number)||number<=0||number>100){
    throw new TypeError('sharePercent must be greater than 0 and at most 100');
  }
  return number;
}

function catalogueLabel(item){
  return String(
    item?.displayName
    ||item?.displayNames?.pl
    ||item?.display_name_pl
    ||item?.key
    ||''
  ).trim();
}

function inventoryLabel(item,catalogue=[]){
  const custom=String(item?.customName||item?.custom_name||'').trim();
  if(custom)return custom;
  const key=String(item?.catalogueKey||item?.wood_key||'').trim();
  const found=(catalogue||[]).find(entry=>String(entry?.key||'')===key);
  return catalogueLabel(found)||key;
}

export function sessionWoodInputFromForm(form,{catalogue=[],inventory=[]}={}){
  if(!form?.get)throw new TypeError('FormData-like input is required');
  const choice=selected(form.get('woodSource'));
  const sharePercent=percent(form.get('sharePercent'));

  if(choice.kind===WoodMixSource.CATALOGUE){
    const item=(catalogue||[]).find(entry=>String(entry?.key||'')===choice.id&&entry?.active!==false);
    const name=catalogueLabel(item);
    if(!item||!name)throw new TypeError('Select a valid catalogue wood');
    return Object.freeze({
      sourceKind:WoodMixSource.CATALOGUE,
      woodKey:String(item.key),
      inventoryItemId:null,
      nameSnapshot:name,
      sharePercent
    });
  }

  const item=(inventory||[]).find(entry=>
    String(entry?.id||'')===choice.id
    &&!entry?.archivedAt
    &&entry?.available!==false
  );
  if(!item)throw new TypeError('Select an available inventory wood');
  const name=inventoryLabel(item,catalogue);
  if(!name)throw new TypeError('Inventory wood has no usable name');

  return Object.freeze({
    sourceKind:WoodMixSource.INVENTORY,
    woodKey:String(item.catalogueKey||item.wood_key||'').trim()||null,
    inventoryItemId:String(item.id),
    nameSnapshot:name,
    sharePercent
  });
}
